import React from 'react';
import './CustomerPhoneNumberInput.scss';
import CustomerSelectInput from '../customerSelectInput/CustomerSelectInput';
import { ReactComponent as Arrow } from '../../../../resources/images/svg/arrow.svg';
import CustomerPhoneInputFormatted from '../customerPhoneInputFormatted/CustomerPhoneInputFormatted';

function CustomerPhoneNumberInput({
  name,
  label,
  className,
  errorMessage,
  selectName,
  options,
  rules = [],
  codeSelectDisabled = false,
  disabled = false,
  noMask = false,
}) {
  return (
    <div className={`customer-phone-number-input ${className}`}>
      <CustomerPhoneInputFormatted
        rules={rules}
        name={name}
        label={label}
        errorMessage={errorMessage}
        disabled={disabled}
        noMask={noMask}
      />
      <CustomerSelectInput
        disabled={codeSelectDisabled}
        arrow={<Arrow />}
        name={selectName}
        options={options}
        search={false}
        className="white-background"
      />
    </div>
  );
}

export default CustomerPhoneNumberInput;
